const TOOGLE_HAMBURGER = "TOOGLE_HAMBURGER";

export {
    TOOGLE_HAMBURGER
}